import { Observable } from 'rxjs';

export enum AttributeType { Integer, Boolean, Enumerated, Sequence, Set_Of, Byte_String, Octet_String };

export interface IAttribute {
    readonly name: string;
    readonly type: AttributeType;
    readonly structure: Object;
    readonly isId: boolean; // Whether this is an ID attribute
    readonly unit: string;
    value?: any;
    localValue?: any;
    isLocal: boolean;
    toDelete: boolean;

    // readonly properties
    readonly isInteger: boolean;
    readonly isBoolean: boolean;
    readonly isEnumerated: boolean;
    readonly isSequence: boolean;
    readonly isSetOf: boolean;
    readonly isByteString: boolean;
    readonly isOctetString: boolean;
    readonly isPassword: boolean;
    readonly isOptional: boolean;
    readonly isUsed: boolean;
    readonly isCreatable: boolean;
    readonly isSettable: boolean;
    readonly isMask: boolean;
    readonly isFiltering: boolean;
    readonly isUsedWhen: boolean;
    readonly isOneInstance: boolean;
    readonly isValid: boolean;
    readonly isModified: boolean;
    readonly isUtf8: boolean;
    readonly isSimpleType: boolean;
    readonly defaultValue: any;

    valueChanges(): Observable<any>;
    localValueChanges(): Observable<any>;
    isUsedChanges(): Observable<boolean>;
    isModifiedChanges(): Observable<boolean>;

    clearLocalChanges(): void;

    evaluateUsedWhen(objectData: Object): void;
    evaluateValidity();

    existLocalSubAttr(): boolean;
    removeLocalSubAttr(): void;
    removeSubAttrMarkedToDelete(): void;
    getStringValue(): string;
    hasValueChanged(): boolean;

    getConstraints(): Object | RegExp;

    toString(): string;
}
